import { render } from "./Time.vue?vue&type=template&id=3c8a0a8d"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=3c8a0a8d&lang=scss"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__